<template>
  <div class="control">
    <div
      class="custom-input"
      :class="space ? 'spaced' : 'not-spaced'"
      :style="{
        height: height,
        'min-height': minHeight,
        'max-height': maxHeight,
      }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputBox',
  props: {
    space: {
      type: Boolean,
      required: false,
      default: true,
    },
    height: {
      type: String,
      required: false,
      default: 'auto',
    },
    minHeight: {
      type: String,
      required: false,
      default: 'initial',
    },
    maxHeight: {
      type: String,
      required: false,
      default: 'initial',
    },
  },
};
</script>

<style lang="scss" scoped>
.spaced {
  padding-bottom: 7px;
  padding-top: 7px;
}
.not-spaced {
  padding-bottom: 0;
  padding-top: 0;
}

.custom-input {
  align-items: center;
  box-sizing: border-box;
  /* display: inline-flex; */
  // height: auto;
  // max-height: 384px;
  overflow-y: scroll;
  /* justify-content: flex-start; */
  max-width: 100%;
  padding-left: 11px;
  padding-right: 11px;
  /* position: relative; */
  width: 100%;
  font-family: Arial;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: start;
  text-size-adjust: 100%;
  vertical-align: top;
  color: rgb(76, 76, 76);
  background-color: rgb(255, 255, 255);
  // border-bottom-color: rgb(172, 136, 86);
  border-bottom-color: rgb(219, 219, 219);
  border-bottom-style: solid;
  border-bottom-width: 1.25px;
  border-image-outset: 0;
  border-image-repeat: stretch;
  border-image-slice: 100%;
  border-image-source: none;
  border-image-width: 1;
  // border-left-color: rgb(172, 136, 86);
  border-left-color: rgb(219, 219, 219);
  border-left-style: solid;
  border-left-width: 1.25px;
  // border-right-color: rgb(172, 136, 86);
  border-right-color: rgb(219, 219, 219);
  border-right-style: solid;
  border-right-width: 1.25px;
  // border-top-color: rgb(172, 136, 86);
  border-top-color: rgb(219, 219, 219);
  border-top-style: solid;
  border-top-width: 1.25px;
  box-shadow: rgba(10, 10, 10, 0.05) 0px 1px 2px 0px inset;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  appearance: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
</style>
